var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';
import { RequerimentosApi } from '../../../../apis/requerimento-api';
import { HandleError } from '../../../utils/HandleError';
import { ConfirmacaoAnexos } from '../../Cadastro/QuintaAba/ConfirmacaoAnexos';
import { filterRenderChecklist } from '../../Cadastro/RequerimentoCadastroRoot';
import { ViewSection } from '../components/ViewSection';
export var AbaChecklist = function (_a) {
    var requerimento = _a.requerimento;
    var _b = useState(null), checklist = _b[0], setChecklist = _b[1];
    var _c = useState(false), loading = _c[0], setLoading = _c[1];
    var _d = useState(undefined), error = _d[0], setError = _d[1];
    var _e = useState([]), indexViewed = _e[0], setIndexViewed = _e[1];
    useEffect(function () {
        handleLoadChecklist();
    }, []);
    var handleLoadChecklist = function () {
        setLoading(true);
        RequerimentosApi.checklist(requerimento.id)
            .then(function (response) {
            setLoading(false);
            setChecklist(filterRenderChecklist(response));
        })
            .catch(function (err) {
            setLoading(false);
            setError(err);
        });
    };
    if (loading) {
        return (_jsx(Box, __assign({ sx: { display: 'flex', justifyContent: 'center', p: 4 } }, { children: _jsx(CircularProgress, {}) })));
    }
    var hasSessoes = (checklist === null || checklist === void 0 ? void 0 : checklist.sessoes) && checklist.sessoes.length > 0;
    return (_jsxs(Box, __assign({ sx: { mt: 2 } }, { children: [_jsx(Typography, __assign({ variant: "h6", sx: { textAlign: 'center', mb: 4, fontWeight: 700, color: '#424242' } }, { children: "Visualizar os Anexos" })), hasSessoes ? (checklist.sessoes.map(function (sessao) { return (_jsx(ConfirmacaoAnexos, { sessao: sessao, requerimento: requerimento, indexViewed: indexViewed, setIndexViewed: setIndexViewed }, sessao.id)); })) : (_jsx(ViewSection, __assign({ title: "Checklist" }, { children: _jsx(Typography, __assign({ textAlign: "center", color: "textSecondary", sx: { py: 4 } }, { children: "Nenhum anexo foi coletado para este requerimento." })) }))), _jsx(HandleError, { error: error, handleClose: function () { return setError(undefined); } })] })));
};
